// ISO 3166-1 alpha-2 country list — italian & english labels.
// Persisted on the client as the alpha-2 code (e.g. "IT"), displayed with the
// user's active language.
export const COUNTRIES = [
  { code: "AF", it: "Afghanistan", en: "Afghanistan" },
  { code: "AL", it: "Albania", en: "Albania" },
  { code: "DZ", it: "Algeria", en: "Algeria" },
  { code: "AD", it: "Andorra", en: "Andorra" },
  { code: "AO", it: "Angola", en: "Angola" },
  { code: "AG", it: "Antigua e Barbuda", en: "Antigua and Barbuda" },
  { code: "AR", it: "Argentina", en: "Argentina" },
  { code: "AM", it: "Armenia", en: "Armenia" },
  { code: "AU", it: "Australia", en: "Australia" },
  { code: "AT", it: "Austria", en: "Austria" },
  { code: "AZ", it: "Azerbaigian", en: "Azerbaijan" },
  { code: "BS", it: "Bahamas", en: "Bahamas" },
  { code: "BH", it: "Bahrein", en: "Bahrain" },
  { code: "BD", it: "Bangladesh", en: "Bangladesh" },
  { code: "BB", it: "Barbados", en: "Barbados" },
  { code: "BY", it: "Bielorussia", en: "Belarus" },
  { code: "BE", it: "Belgio", en: "Belgium" },
  { code: "BZ", it: "Belize", en: "Belize" },
  { code: "BJ", it: "Benin", en: "Benin" },
  { code: "BT", it: "Bhutan", en: "Bhutan" },
  { code: "BO", it: "Bolivia", en: "Bolivia" },
  { code: "BA", it: "Bosnia ed Erzegovina", en: "Bosnia and Herzegovina" },
  { code: "BW", it: "Botswana", en: "Botswana" },
  { code: "BR", it: "Brasile", en: "Brazil" },
  { code: "BN", it: "Brunei", en: "Brunei" },
  { code: "BG", it: "Bulgaria", en: "Bulgaria" },
  { code: "BF", it: "Burkina Faso", en: "Burkina Faso" },
  { code: "BI", it: "Burundi", en: "Burundi" },
  { code: "KH", it: "Cambogia", en: "Cambodia" },
  { code: "CM", it: "Camerun", en: "Cameroon" },
  { code: "CA", it: "Canada", en: "Canada" },
  { code: "CV", it: "Capo Verde", en: "Cape Verde" },
  { code: "CF", it: "Repubblica Centrafricana", en: "Central African Republic" },
  { code: "TD", it: "Ciad", en: "Chad" },
  { code: "CL", it: "Cile", en: "Chile" },
  { code: "CN", it: "Cina", en: "China" },
  { code: "CO", it: "Colombia", en: "Colombia" },
  { code: "KM", it: "Comore", en: "Comoros" },
  { code: "CG", it: "Congo", en: "Congo" },
  { code: "CD", it: "Rep. Dem. del Congo", en: "DR Congo" },
  { code: "CR", it: "Costa Rica", en: "Costa Rica" },
  { code: "CI", it: "Costa d'Avorio", en: "Ivory Coast" },
  { code: "HR", it: "Croazia", en: "Croatia" },
  { code: "CU", it: "Cuba", en: "Cuba" },
  { code: "CY", it: "Cipro", en: "Cyprus" },
  { code: "CZ", it: "Repubblica Ceca", en: "Czech Republic" },
  { code: "DK", it: "Danimarca", en: "Denmark" },
  { code: "DJ", it: "Gibuti", en: "Djibouti" },
  { code: "DM", it: "Dominica", en: "Dominica" },
  { code: "DO", it: "Rep. Dominicana", en: "Dominican Republic" },
  { code: "EC", it: "Ecuador", en: "Ecuador" },
  { code: "EG", it: "Egitto", en: "Egypt" },
  { code: "SV", it: "El Salvador", en: "El Salvador" },
  { code: "GQ", it: "Guinea Equatoriale", en: "Equatorial Guinea" },
  { code: "ER", it: "Eritrea", en: "Eritrea" },
  { code: "EE", it: "Estonia", en: "Estonia" },
  { code: "SZ", it: "Eswatini", en: "Eswatini" },
  { code: "ET", it: "Etiopia", en: "Ethiopia" },
  { code: "FJ", it: "Figi", en: "Fiji" },
  { code: "FI", it: "Finlandia", en: "Finland" },
  { code: "FR", it: "Francia", en: "France" },
  { code: "GA", it: "Gabon", en: "Gabon" },
  { code: "GM", it: "Gambia", en: "Gambia" },
  { code: "GE", it: "Georgia", en: "Georgia" },
  { code: "DE", it: "Germania", en: "Germany" },
  { code: "GH", it: "Ghana", en: "Ghana" },
  { code: "GR", it: "Grecia", en: "Greece" },
  { code: "GD", it: "Grenada", en: "Grenada" },
  { code: "GT", it: "Guatemala", en: "Guatemala" },
  { code: "GN", it: "Guinea", en: "Guinea" },
  { code: "GW", it: "Guinea-Bissau", en: "Guinea-Bissau" },
  { code: "GY", it: "Guyana", en: "Guyana" },
  { code: "HT", it: "Haiti", en: "Haiti" },
  { code: "HN", it: "Honduras", en: "Honduras" },
  { code: "HU", it: "Ungheria", en: "Hungary" },
  { code: "IS", it: "Islanda", en: "Iceland" },
  { code: "IN", it: "India", en: "India" },
  { code: "ID", it: "Indonesia", en: "Indonesia" },
  { code: "IR", it: "Iran", en: "Iran" },
  { code: "IQ", it: "Iraq", en: "Iraq" },
  { code: "IE", it: "Irlanda", en: "Ireland" },
  { code: "IL", it: "Israele", en: "Israel" },
  { code: "IT", it: "Italia", en: "Italy" },
  { code: "JM", it: "Giamaica", en: "Jamaica" },
  { code: "JP", it: "Giappone", en: "Japan" },
  { code: "JO", it: "Giordania", en: "Jordan" },
  { code: "KZ", it: "Kazakistan", en: "Kazakhstan" },
  { code: "KE", it: "Kenya", en: "Kenya" },
  { code: "KI", it: "Kiribati", en: "Kiribati" },
  { code: "KW", it: "Kuwait", en: "Kuwait" },
  { code: "KG", it: "Kirghizistan", en: "Kyrgyzstan" },
  { code: "LA", it: "Laos", en: "Laos" },
  { code: "LV", it: "Lettonia", en: "Latvia" },
  { code: "LB", it: "Libano", en: "Lebanon" },
  { code: "LS", it: "Lesotho", en: "Lesotho" },
  { code: "LR", it: "Liberia", en: "Liberia" },
  { code: "LY", it: "Libia", en: "Libya" },
  { code: "LI", it: "Liechtenstein", en: "Liechtenstein" },
  { code: "LT", it: "Lituania", en: "Lithuania" },
  { code: "LU", it: "Lussemburgo", en: "Luxembourg" },
  { code: "MG", it: "Madagascar", en: "Madagascar" },
  { code: "MW", it: "Malawi", en: "Malawi" },
  { code: "MY", it: "Malesia", en: "Malaysia" },
  { code: "MV", it: "Maldive", en: "Maldives" },
  { code: "ML", it: "Mali", en: "Mali" },
  { code: "MT", it: "Malta", en: "Malta" },
  { code: "MH", it: "Isole Marshall", en: "Marshall Islands" },
  { code: "MR", it: "Mauritania", en: "Mauritania" },
  { code: "MU", it: "Mauritius", en: "Mauritius" },
  { code: "MX", it: "Messico", en: "Mexico" },
  { code: "FM", it: "Micronesia", en: "Micronesia" },
  { code: "MD", it: "Moldavia", en: "Moldova" },
  { code: "MC", it: "Monaco", en: "Monaco" },
  { code: "MN", it: "Mongolia", en: "Mongolia" },
  { code: "ME", it: "Montenegro", en: "Montenegro" },
  { code: "MA", it: "Marocco", en: "Morocco" },
  { code: "MZ", it: "Mozambico", en: "Mozambique" },
  { code: "MM", it: "Myanmar", en: "Myanmar" },
  { code: "NA", it: "Namibia", en: "Namibia" },
  { code: "NR", it: "Nauru", en: "Nauru" },
  { code: "NP", it: "Nepal", en: "Nepal" },
  { code: "NL", it: "Paesi Bassi", en: "Netherlands" },
  { code: "NZ", it: "Nuova Zelanda", en: "New Zealand" },
  { code: "NI", it: "Nicaragua", en: "Nicaragua" },
  { code: "NE", it: "Niger", en: "Niger" },
  { code: "NG", it: "Nigeria", en: "Nigeria" },
  { code: "KP", it: "Corea del Nord", en: "North Korea" },
  { code: "MK", it: "Macedonia del Nord", en: "North Macedonia" },
  { code: "NO", it: "Norvegia", en: "Norway" },
  { code: "OM", it: "Oman", en: "Oman" },
  { code: "PK", it: "Pakistan", en: "Pakistan" },
  { code: "PW", it: "Palau", en: "Palau" },
  { code: "PA", it: "Panama", en: "Panama" },
  { code: "PG", it: "Papua Nuova Guinea", en: "Papua New Guinea" },
  { code: "PY", it: "Paraguay", en: "Paraguay" },
  { code: "PE", it: "Perù", en: "Peru" },
  { code: "PH", it: "Filippine", en: "Philippines" },
  { code: "PL", it: "Polonia", en: "Poland" },
  { code: "PT", it: "Portogallo", en: "Portugal" },
  { code: "QA", it: "Qatar", en: "Qatar" },
  { code: "RO", it: "Romania", en: "Romania" },
  { code: "RU", it: "Russia", en: "Russia" },
  { code: "RW", it: "Ruanda", en: "Rwanda" },
  { code: "KN", it: "Saint Kitts e Nevis", en: "Saint Kitts and Nevis" },
  { code: "LC", it: "Santa Lucia", en: "Saint Lucia" },
  { code: "VC", it: "Saint Vincent e Grenadine", en: "Saint Vincent and the Grenadines" },
  { code: "WS", it: "Samoa", en: "Samoa" },
  { code: "SM", it: "San Marino", en: "San Marino" },
  { code: "ST", it: "São Tomé e Príncipe", en: "Sao Tome and Principe" },
  { code: "SA", it: "Arabia Saudita", en: "Saudi Arabia" },
  { code: "SN", it: "Senegal", en: "Senegal" },
  { code: "RS", it: "Serbia", en: "Serbia" },
  { code: "SC", it: "Seychelles", en: "Seychelles" },
  { code: "SL", it: "Sierra Leone", en: "Sierra Leone" },
  { code: "SG", it: "Singapore", en: "Singapore" },
  { code: "SK", it: "Slovacchia", en: "Slovakia" },
  { code: "SI", it: "Slovenia", en: "Slovenia" },
  { code: "SB", it: "Isole Salomone", en: "Solomon Islands" },
  { code: "SO", it: "Somalia", en: "Somalia" },
  { code: "ZA", it: "Sudafrica", en: "South Africa" },
  { code: "KR", it: "Corea del Sud", en: "South Korea" },
  { code: "SS", it: "Sud Sudan", en: "South Sudan" },
  { code: "ES", it: "Spagna", en: "Spain" },
  { code: "LK", it: "Sri Lanka", en: "Sri Lanka" },
  { code: "SD", it: "Sudan", en: "Sudan" },
  { code: "SR", it: "Suriname", en: "Suriname" },
  { code: "SE", it: "Svezia", en: "Sweden" },
  { code: "CH", it: "Svizzera", en: "Switzerland" },
  { code: "SY", it: "Siria", en: "Syria" },
  { code: "TW", it: "Taiwan", en: "Taiwan" },
  { code: "TJ", it: "Tagikistan", en: "Tajikistan" },
  { code: "TZ", it: "Tanzania", en: "Tanzania" },
  { code: "TH", it: "Thailandia", en: "Thailand" },
  { code: "TL", it: "Timor Est", en: "Timor-Leste" },
  { code: "TG", it: "Togo", en: "Togo" },
  { code: "TO", it: "Tonga", en: "Tonga" },
  { code: "TT", it: "Trinidad e Tobago", en: "Trinidad and Tobago" },
  { code: "TN", it: "Tunisia", en: "Tunisia" },
  { code: "TR", it: "Turchia", en: "Turkey" },
  { code: "TM", it: "Turkmenistan", en: "Turkmenistan" },
  { code: "TV", it: "Tuvalu", en: "Tuvalu" },
  { code: "UG", it: "Uganda", en: "Uganda" },
  { code: "UA", it: "Ucraina", en: "Ukraine" },
  { code: "AE", it: "Emirati Arabi Uniti", en: "United Arab Emirates" },
  { code: "GB", it: "Regno Unito", en: "United Kingdom" },
  { code: "US", it: "Stati Uniti", en: "United States" },
  { code: "UY", it: "Uruguay", en: "Uruguay" },
  { code: "UZ", it: "Uzbekistan", en: "Uzbekistan" },
  { code: "VU", it: "Vanuatu", en: "Vanuatu" },
  { code: "VA", it: "Città del Vaticano", en: "Vatican City" },
  { code: "VE", it: "Venezuela", en: "Venezuela" },
  { code: "VN", it: "Vietnam", en: "Vietnam" },
  { code: "YE", it: "Yemen", en: "Yemen" },
  { code: "ZM", it: "Zambia", en: "Zambia" },
  { code: "ZW", it: "Zimbabwe", en: "Zimbabwe" },
];

export function countryLabel(code, lang = "it") {
  if (!code) return "";
  const c = COUNTRIES.find((x) => x.code === String(code).toUpperCase());
  if (c) return lang === "en" ? c.en : c.it;
  return code;
}
